const THEME_PALETTES = {
  'Ravenwood Classic': {
    dark: {
      bg: '#081a2e', surface: '#0a2342', surfaceAlt: '#0d2d54', border: '#1a3a5c',
      text: '#fffdf7', textSecondary: '#78a1bb', textMuted: '#4a6a8a',
      accent: '#d9ad2b', accentHover: '#c49b20',
      navActive: '#0d2d54', navText: '#78a1bb', navActiveText: '#d9ad2b',
      statusGreenBg: '#0a2e1a', statusGreenText: '#4ade80',
      statusYellowBg: '#2e2010', statusYellowText: '#fbbf24',
      statusBlueBg: '#0a1e2e', statusBlueText: '#78a1bb',
      statusGrayBg: '#1a2a3a', statusGrayText: '#4a6a8a',
      logo: '/images/logo-light.png', mode: 'dark',
    },
    light: {
      bg: '#fffdf7', surface: '#ffffff', surfaceAlt: '#f5f0e8', border: '#e0d8c8',
      text: '#0a2342', textSecondary: '#4a6a8a', textMuted: '#9aaabb',
      accent: '#d9ad2b', accentHover: '#c49b20',
      navActive: '#f5f0e8', navText: '#4a6a8a', navActiveText: '#0a2342',
      statusGreenBg: '#e8f5ee', statusGreenText: '#166534',
      statusYellowBg: '#fef9e7', statusYellowText: '#854d0e',
      statusBlueBg: '#e8f0f5', statusBlueText: '#1e4a6a',
      statusGrayBg: '#f0ece4', statusGrayText: '#6b7280',
      logo: '/images/logo-dark.png', mode: 'light',
    }
  },
  'Coffee Shop': {
    dark: {
      bg: '#110a04', surface: '#1c1008', surfaceAlt: '#2a1a0e', border: '#3a2518',
      text: '#f0e6d3', textSecondary: '#b89070', textMuted: '#7a5a3a',
      accent: '#c47a2b', accentHover: '#a86820',
      navActive: '#2a1a0e', navText: '#b89070', navActiveText: '#c47a2b',
      statusGreenBg: '#0f1e0a', statusGreenText: '#86efac',
      statusYellowBg: '#2e1e08', statusYellowText: '#fbbf24',
      statusBlueBg: '#0a1520', statusBlueText: '#93c5fd',
      statusGrayBg: '#1a1208', statusGrayText: '#9a7a5a',
      logo: '/images/logo-light.png', mode: 'dark',
    },
    light: {
      bg: '#fdf6ee', surface: '#fff8f0', surfaceAlt: '#f5ece0', border: '#e8d8c4',
      text: '#2a1a0e', textSecondary: '#7a5a3a', textMuted: '#b89070',
      accent: '#c47a2b', accentHover: '#a86820',
      navActive: '#f5ece0', navText: '#7a5a3a', navActiveText: '#2a1a0e',
      statusGreenBg: '#eef6e8', statusGreenText: '#166534',
      statusYellowBg: '#fef4e0', statusYellowText: '#854d0e',
      statusBlueBg: '#e8f0f8', statusBlueText: '#1e4a6a',
      statusGrayBg: '#f0e8dc', statusGrayText: '#6b5040',
      logo: '/images/logo-dark.png', mode: 'light',
    }
  },
  'Deep Woods': {
    dark: {
      bg: '#060f09', surface: '#0d1f14', surfaceAlt: '#162a1c', border: '#1e3a26',
      text: '#dff0d8', textSecondary: '#6a9e6f', textMuted: '#3a6040',
      accent: '#7ec87a', accentHover: '#6ab866',
      navActive: '#162a1c', navText: '#6a9e6f', navActiveText: '#7ec87a',
      statusGreenBg: '#0a1e0d', statusGreenText: '#86efac',
      statusYellowBg: '#1e2008', statusYellowText: '#fbbf24',
      statusBlueBg: '#081520', statusBlueText: '#93c5fd',
      statusGrayBg: '#121a14', statusGrayText: '#6a9e6f',
      logo: '/images/logo-light.png', mode: 'dark',
    },
    light: {
      bg: '#f0f8f0', surface: '#f8fff8', surfaceAlt: '#e8f5e8', border: '#c8e0c8',
      text: '#0d1f14', textSecondary: '#3a6040', textMuted: '#6a9e6f',
      accent: '#4a9e46', accentHover: '#3a8e36',
      navActive: '#e8f5e8', navText: '#3a6040', navActiveText: '#0d1f14',
      statusGreenBg: '#e0f0e0', statusGreenText: '#166534',
      statusYellowBg: '#f8f4e0', statusYellowText: '#854d0e',
      statusBlueBg: '#e0ecf8', statusBlueText: '#1e4a6a',
      statusGrayBg: '#e8f0e8', statusGrayText: '#4a6a4a',
      logo: '/images/logo-dark.png', mode: 'light',
    }
  },
  'Neon City': {
    dark: {
      bg: '#050508', surface: '#0a0a0f', surfaceAlt: '#12121a', border: '#1e1e2e',
      text: '#f0f0ff', textSecondary: '#9090c0', textMuted: '#505080',
      accent: '#ff2d78', accentHover: '#e01a65',
      navActive: '#12121a', navText: '#9090c0', navActiveText: '#ff2d78',
      statusGreenBg: '#001a12', statusGreenText: '#00ff9f',
      statusYellowBg: '#1a1a00', statusYellowText: '#fcee09',
      statusBlueBg: '#00101a', statusBlueText: '#00f5d4',
      statusGrayBg: '#0a0a14', statusGrayText: '#9090c0',
      logo: '/images/logo-light.png', mode: 'dark',
    },
    light: {
      bg: '#f0f0ff', surface: '#ffffff', surfaceAlt: '#e8e8f8', border: '#c8c8e8',
      text: '#0a0a2a', textSecondary: '#4040a0', textMuted: '#8080b0',
      accent: '#cc0060', accentHover: '#aa0050',
      navActive: '#e8e8f8', navText: '#4040a0', navActiveText: '#0a0a2a',
      statusGreenBg: '#e0fff0', statusGreenText: '#006634',
      statusYellowBg: '#fffce0', statusYellowText: '#806000',
      statusBlueBg: '#e0f8ff', statusBlueText: '#006080',
      statusGrayBg: '#e8e8f8', statusGrayText: '#4040a0',
      logo: '/images/logo-dark.png', mode: 'light',
    }
  },
  'Dusty Rose': {
    dark: {
      bg: '#120c10', surface: '#1f1218', surfaceAlt: '#2a1a22', border: '#3a2230',
      text: '#f0dde5', textSecondary: '#b08090', textMuted: '#705060',
      accent: '#d4829a', accentHover: '#c07088',
      navActive: '#2a1a22', navText: '#b08090', navActiveText: '#d4829a',
      statusGreenBg: '#0a1e14', statusGreenText: '#86efac',
      statusYellowBg: '#2e1e10', statusYellowText: '#fbbf24',
      statusBlueBg: '#0a1020', statusBlueText: '#93c5fd',
      statusGrayBg: '#1a1018', statusGrayText: '#b08090',
      logo: '/images/logo-light.png', mode: 'dark',
    },
    light: {
      bg: '#fff5f7', surface: '#ffffff', surfaceAlt: '#fce8ed', border: '#f0ccd5',
      text: '#2a0e18', textSecondary: '#8a4a5a', textMuted: '#c090a0',
      accent: '#c4607a', accentHover: '#b04e68',
      navActive: '#fce8ed', navText: '#8a4a5a', navActiveText: '#2a0e18',
      statusGreenBg: '#e8f5ee', statusGreenText: '#166534',
      statusYellowBg: '#fef9e7', statusYellowText: '#854d0e',
      statusBlueBg: '#e8f0f5', statusBlueText: '#1e4a6a',
      statusGrayBg: '#f8eef2', statusGrayText: '#6b5060',
      logo: '/images/logo-dark.png', mode: 'light',
    }
  },
  'Retro Wave': {
    dark: {
      bg: '#07030f', surface: '#0d1a2a', surfaceAlt: '#112236', border: '#1a3048',
      text: '#e8f4ff', textSecondary: '#60a0d0', textMuted: '#305080',
      accent: '#ff6ec7', accentHover: '#e055b0',
      navActive: '#112236', navText: '#60a0d0', navActiveText: '#ff6ec7',
      statusGreenBg: '#001a20', statusGreenText: '#00d4ff',
      statusYellowBg: '#1a1020', statusYellowText: '#ff6ec7',
      statusBlueBg: '#001530', statusBlueText: '#60a0d0',
      statusGrayBg: '#0a1020', statusGrayText: '#60a0d0',
      logo: '/images/logo-light.png', mode: 'dark',
    },
    light: {
      bg: '#f0f5ff', surface: '#ffffff', surfaceAlt: '#e0ecff', border: '#b0cce8',
      text: '#071030', textSecondary: '#305080', textMuted: '#7090b0',
      accent: '#c0408a', accentHover: '#a03070',
      navActive: '#e0ecff', navText: '#305080', navActiveText: '#071030',
      statusGreenBg: '#e0f8ff', statusGreenText: '#006080',
      statusYellowBg: '#fff0f8', statusYellowText: '#80205a',
      statusBlueBg: '#e0ecff', statusBlueText: '#305080',
      statusGrayBg: '#e8f0f8', statusGrayText: '#4a7090',
      logo: '/images/logo-dark.png', mode: 'light',
    }
  },
}

function buildTheme(themeName, mode, fontSize, rowDensity) {
  const palette = THEME_PALETTES[themeName] || THEME_PALETTES['Ravenwood Classic']
  const contentZoom = fontSize === 'Small' ? 0.85 : fontSize === 'Large' ? 1.15 : 1
  const rowPadding = rowDensity === 'Compact' ? '5px 20px' : '10px 20px'
  return { ...palette[mode], themeName, mode, contentZoom, rowPadding }
}

export { THEME_PALETTES, buildTheme }